<template>
  <div class="col-xs-12 col-md-6 form-group">
    <label class="control-label" v-if="label">{{ label }}</label>
    <dropzone-upload-cloud
      :ref="name"
      :maxFiles="maxFiles"
      :url="url"
      name="upload"
      :class="{ 'required': true }"
      :value="value"
      :aditionalParams="{ }"
      :disabled="isBlocked"
      @fileSending="fileSending()"
      @fileRemoved="removeDocumento($event)"
      @fileAdded="notificarEnvio($event)"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import ArquivoService from "../../../../domain/web/ArquivoService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "c-protocolo-anexo",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: {
      type: Array,
      default: () => []
    },
    required: Boolean,
    loading: {
      type: Boolean,
      default: false
    },
    maxFiles: {
      type: Number,
      default: null // null significa sem limite
    }
  },
  mounted() {
    this.$el.value = this.value;
  },
  computed: {
    url() {
      return `${
        this.$http.options.root
      }arquivo/upload/atendimento.grupointegrado.br`;
    }
    ,
    isBlocked() {
    return this.loading; 
  }
  },
  methods: {
    fileSending() {
      this.$emit('update:loading', true);
    },
    notificarEnvio(arquivoRecebido) {
      this.$emit('update:loading', false);
      const listaAtual = Array.isArray(this.value) ? [...this.value] : [];
      if (this.maxFiles && listaAtual.length >= this.maxFiles) {
        this.removeDocumento(arquivoRecebido, true); 

        const dropzoneComponent = this.$refs[this.name];
        if (dropzoneComponent && dropzoneComponent.$refs[this.name]) {
          dropzoneComponent.$refs[this.name].removeAllFiles(true); 
        }

        Swal({
          type: "warning",
          title: "Limite atingido",
          text: `Apenas ${this.maxFiles} arquivo é permitido.`,
          confirmButtonText: "Ok"
        });
        return;
      }

      const jaExiste = listaAtual.find(doc => doc.id === arquivoRecebido.id);
      if (!jaExiste) {
        listaAtual.push(arquivoRecebido);
        this.$emit('input', listaAtual);
      }
    },

    removeDocumento(anexoAtendimento, silencioso = false) {
      if (this.loading && !silencioso) {
        return Promise.reject();
      }
      const documento = {
        id: anexoAtendimento.id,
        file: anexoAtendimento.path
      };

      const arquivoService = new ArquivoService(this.$http);
      return arquivoService
        .deleteFile(
          "atendimento.grupointegrado.br",
          anexoAtendimento.path,
          anexoAtendimento.id
        )
        .then(
          response => {
            if (!silencioso) {
              const listaRestante = this.value.filter(doc => doc.id !== anexoAtendimento.id);
              this.$emit('input', listaRestante);
            }
            return response;
          },
          err => {
            if (!silencioso) {
              SwalMessage.errorMessage(err);
            } else {
              console.error("Erro ao limpar arquivo excedente do servidor:", err);
            }
          }
        );

    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/Anexo.vue